// Daily flat-rate driver plan helpers. Pure module — no firebase/store
// imports, so it is safely importable from web columns, mobile screens,
// and common actions alike.
//
// A driver is flat-rate ONLY when all of these hold (must match the
// server predicate in functions/common/flatRate.js — a driver whose car
// type has no daily_flat_rate behaves as a normal per-trip commission
// driver everywhere):
//   settings.driverFlatRateEnabled === true
//   profile.commissionMode === 'flat_daily'
//   no fleetadmin (independent drivers only)
//   car type daily_flat_rate > 0

export const getDailyFlatRate = (profile, cars) => {
    if (!profile || !Array.isArray(cars)) return 0;
    const car = cars.find((c) => c && c.name === profile.carType);
    const rate = car ? parseFloat(car.daily_flat_rate) : 0;
    return Number.isFinite(rate) && rate > 0 ? rate : 0;
};

export const isFlatRateDriver = (profile, settings, cars) => {
    return !!(
        profile && settings &&
        settings.driverFlatRateEnabled === true &&
        profile.usertype === 'driver' &&
        profile.commissionMode === 'flat_daily' &&
        // Fleet drivers are excluded unless flatRateAllowFleetDrivers is on;
        // when allowed, the daily fee replaces only the platform commission —
        // the fleet admin's per-trip cut still applies at settlement.
        (!profile.fleetadmin || settings.flatRateAllowFleetDrivers === true) &&
        getDailyFlatRate(profile, cars) > 0
    );
};

// null when the driver's car type has no flat rate configured.
export const getFlatRateDaysRemaining = (profile, cars) => {
    const rate = getDailyFlatRate(profile, cars);
    if (!rate) return null;
    const balance = parseFloat(profile.topUpBalance) || 0;
    return Math.max(0, Math.floor(balance / rate));
};

// Prepaid-day packages offered to flat-rate drivers (FlatRateDaysBar), in
// DISPLAY ORDER, from settings.flatRatePackageDays — a comma-separated
// string ("1,7,30") or an array — so ops can change the values or the order
// from the portal without an app update. Positive whole numbers only,
// de-duplicated, at most 8 (any length up to a year — 60, 90, 365 days are
// fine); anything unusable falls back to [1, 7, 30].
export const DEFAULT_FLAT_RATE_PACKAGE_DAYS = [1, 7, 30];
export const getFlatRatePackageDays = (settings) => {
    const raw = settings ? settings.flatRatePackageDays : undefined;
    const parts = Array.isArray(raw) ? raw : String(raw === undefined || raw === null ? '' : raw).split(/[,\s;]+/);
    const days = [];
    parts.forEach((v) => {
        const n = parseInt(v, 10);
        if (Number.isFinite(n) && n > 0 && n <= 365 && days.indexOf(n) < 0 && days.length < 8) days.push(n);
    });
    return days.length ? days : DEFAULT_FLAT_RATE_PACKAGE_DAYS.slice();
};
